import styles from './SourcesLine.module.css'
import { BasicStyledComponent, DSCredit } from 'shared-definitions/types'
import Linked from 'shared-components/service/Linked'
import SplitterLine from './SplitterLine'

interface SourcesLineProps extends BasicStyledComponent {
  sources: readonly DSCredit[]
}

const SourcesLine: React.VFC<SourcesLineProps> = ({ className, sources }) => (
  <div className={className}>
    <div className={styles.content}>
      <span className={styles.blockTitle}>{'Sources:'}</span>
      {sources.map((item, index) => {
        if (item.pLink) {
          return (
            <Linked className={styles.source} key={index} {...item.pLink}>
              {item.title}
            </Linked>
          )
        }
        return (
          <span key={index} className={styles.source}>
            {item.title}
          </span>
        )
      })}
    </div>
    <SplitterLine />
  </div>
)

export default SourcesLine
